export function absoluteUrl(path) {
    return `${process.env.REACT_APP_BackendURL}${path}`
}
